module.exports = __webpack_public_path__ + "static/media/notebook.027e7e08.svg";